import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { Observable, of, from } from 'rxjs';
import { AuthService, SurveyService } from '../../../services';
import { tap, switchMap, catchError, map, share } from 'rxjs/operators';
// import { LoadingService } from '@schoolbelle/common/loading';
import * as _firebase from 'firebase/app';
const firebase = _firebase;

@Injectable({
  providedIn: 'root'
})
export class AbstractGuard implements CanActivate {
  constructor(
    protected auth: AuthService,
    protected survey: SurveyService,
    protected router: Router,
    // protected loading: LoadingService
  ) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    const survey_id = next.params.survey_id || next.queryParams.survey_id;
    if (survey_id) {
      const survey_access_token = next.queryParams.survey_access_token;
      const checkin = this.survey.getLatest(survey_id)
      .pipe(
        switchMap(() => {
          if (survey_access_token) return this.loginWithSurveyAccessToken(state, survey_access_token, survey_id);
          else return from(this.auth.getIdTokenResult()).pipe(map(idTokenResult=>this.checkAgainstScope(idTokenResult, survey_id)));
        }),
        catchError(e => {
          return of(false).pipe(
            tap(() =>
              console.error(
                'prob internet connection issue -> internet connection error info page',
                e
              )
            )
          );
        }),
        share(),
      );
      // this.loading.open({ message: 'ì¬ì©ì íì¸ ì¤ìëë¤...', busy: checkin.subscribe() });
      return checkin;
    } else {
      return of(true);
    }
  }


  checkAgainstScope(
    idTokenResult: firebase.auth.IdTokenResult,
    survey_id: string
  ): boolean {
    return idTokenResult && idTokenResult.claims.survey_id === survey_id ? true : false;
  }
  private loginWithSurveyAccessToken(
    state: RouterStateSnapshot,
    survey_access_token: string,
    survey_id: string
  ): Observable<boolean> {
    return this.auth.signInWithCustomToken(survey_access_token).pipe(
      map(idTokenResult => this.checkAgainstScope(idTokenResult, survey_id)),
      tap(
        bool =>
          bool !== true
            ? console.log('permission denied -> 403 error info page ')
            : null
      ),
      tap(() => {
        const baseurl = this.removeURLParameter(
          state.url,
          'survey_access_token'
        );
        this.router.navigateByUrl(baseurl);
      })
    );
  }
  private removeURLParameter(url, parameter) {
    //prefer to use l.search if you have a location/link object
    var urlparts = url.split('?');
    if (urlparts.length >= 2) {
      var prefix = encodeURIComponent(parameter) + '=';
      var pars = urlparts[1].split(/[&;]/g);

      //reverse iteration as may be destructive
      for (var i = pars.length; i-- > 0; ) {
        //idiom for string.startsWith
        if (pars[i].lastIndexOf(prefix, 0) !== -1) {
          pars.splice(i, 1);
        }
      }

      return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
    }
    return url;
  }
}
